import { createFromIconfontCN } from "@ant-design/icons";

export default createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2320911_div6s31if17.js",
});
